<template>
    
    <div>
        <v-text-field 
            :label="label" 
            :required="required" 
            :rules="(required) ? [rules.required] : []"
            readonly
            :hide-details="hideDetails"
            :name="name"
            variant="solo-filled"
            class="font-weight-bold"
            v-model="formattedDate"
            >
            <v-menu 
                    v-model="menu"
                    activator="parent"
                    class="w-100 d-block"
                    :close-on-content-click="false"
            >
            <v-card>
                <v-date-picker 
                width="100%"
                :max="maxDate"
                :min="minDate"
                show-adjacent-months
                :view-mode="viewMode"
                v-model="datePicker"
                @update:model-value="updateDate(datePicker)"
                ></v-date-picker>
            </v-card>
        </v-menu>
        </v-text-field>
    </div>

</template>

<script>

export default {
    props:{
        label: {
            type: String,
        },
        name: {
            type: String,
            required: false,
            default: 'date',
        },
        value: {
            type: String,
        },
        required:{
            type: Boolean,
            default: true,
        },
        hideDetails:{
            type: Boolean,
            default: false,
        },
        viewMode:{
            type: String,
            default: 'month',
        },
        min:{
            required: false,
            default: null,
        },
        max:{
            required: false,
            default: null,
        }
    },
    data: () => ({
      menu: false,
      
      rules: {
        required: value => !!value || 'attributes.generic.validation.required',
      },
      datePicker: null,
      formattedDate: null,
      minDate: null,
      maxDate: null,
    }),
    mounted(){

        if(this.min){
            // eslint-disable-next-line vue/no-mutating-props
            this.minDate = this.min;
        }else{
            // eslint-disable-next-line vue/no-mutating-props
            this.minDate = this.$moment().add(4,'hours').startOf('day').format();
        }
        if(this.max){
            // eslint-disable-next-line vue/no-mutating-props
            this.maxDate = this.max
        }else{
            // eslint-disable-next-line vue/no-mutating-props
            this.maxDate = this.$moment().add(1,'year').startOf('day').format();
        }
        
        
        if(this.value){
            this.datePicker = this.$moment(this.value)
            this.formattedDate = this.$moment(this.value).format('ddd DD MMMM yyyy')
        }
        
        this.rules = {
            required: value => !!value || this.translate('attributes.generic.validation.required'),
        };
    },
    methods:{
        translate(string){
            return this.$vuetify.locale.t(string)
        },
        updateDate(date){
            this.formattedDate = this.$moment(date).format('ddd DD MMMM yyyy')
            this.$emit('update', this.$moment(date).format('YYYY-MM-DD'))
            this.menu = false
        }, 
    }
     
}

</script>